import React from "react";

const TopAlbum = ({ name, artist, playcount, image, url }) => {
  //! PARENT COMPANENTDEN GEREKLİ STATELERİ PROP YÖNTEMİ İLE ALDIK.

  return (
    <div className="flex justify-center my-4 ">
      <div
        onClick={() => (window.location.href = url)}
        className="movie flex items-center bg-white border rounded-lg shadow-md md:flex-row md:max-w-xl  hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700"
      >
        <img
          className="object-cover rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg"
          src={image?.[2]["#text"]}
          alt=""
        />
        <div className="flex flex-col justify-between p-4 leading-normal">
          <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
            {name}
          </h5>
          <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
            {artist?.name}
          </p>
        </div>
        <div className="flex flex-col justify-between p-4 leading-normal">
          <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
            {playcount} : play
          </p>
        </div>
      </div>
    </div>
  );
};

export default TopAlbum;
